import React from "react";
import { useLocation } from "react-router-dom";
import { ACESSO_ADMINISTRATIVO } from "../../../helpers/tiposDeAcesso";

interface MenuLateralProps {
  expandido: boolean;
}

const MenuLateral: React.FC<MenuLateralProps> = ({ expandido }) => {
  const location = useLocation();
  const tipoAcesso = localStorage.getItem("tipo_acesso");

  const isAtivo = (path: string) => location.pathname.startsWith(path);

  // Checa se existe local selecionado no localStorage
  const temLocalSelecionado = (() => {
    try {
      const raw = localStorage.getItem("localDeAtendimento");
      if (!raw) return false;
      const obj = JSON.parse(raw);
      // considera selecionado se houver um objeto válido com id
      return !!obj && typeof obj === "object" && obj.id != null;
    } catch {
      return false;
    }
  })();

  return (
    <nav
      className={`menu-lateral ${
        expandido ? "menu-lateral_expandido" : "menu-lateral_minimizado"
      }`}
    >
      <ul className="menu-lateral__lista">
        <li className="menu-lateral__item">
          <a
            href="/listagem-de-inscricoes"
            className={`menu-lateral__link ${
              isAtivo("/listagem-de-inscricoes")
                ? "menu-lateral__link_ativo"
                : ""
            }`}
          >
            <i className="far fa-clipboard-check menu-lateral__icone" />
            <span className="menu-lateral__texto">Inscrições</span>
          </a>
        </li>

        {tipoAcesso === ACESSO_ADMINISTRATIVO && (
          <>
            {/* Sempre visível para admin */}
            <li className="menu-lateral__item">
              <a
                href="/gerenciar-locais-permissoes"
                className={`menu-lateral__link ${
                  isAtivo("/gerenciar-locais-permissoes")
                    ? "menu-lateral__link_ativo"
                    : ""
                }`}
              >
                <i className="far fa-house-user menu-lateral__icone" />
                <span className="menu-lateral__texto">
                  Gerir locais e permissões
                </span>
              </a>
            </li>

            {/* Visíveis apenas SE houver local selecionado */}
            {temLocalSelecionado && (
              <>
                {/* <li className="menu-lateral__item">
                  <a
                    href="/gerenciar-relatorios"
                    className={`menu-lateral__link ${
                      isAtivo("/gerenciar-relatorios")
                        ? "menu-lateral__link_ativo"
                        : ""
                    }`}
                  >
                    <i className="far fa-file-text menu-lateral__icone" />
                    <span className="menu-lateral__texto">Relatórios</span>
                  </a>
                </li> */}

                <li className="menu-lateral__item">
                  <a
                    href="/agenda"
                    className={`menu-lateral__link ${
                      isAtivo("/agenda") ? "menu-lateral__link_ativo" : ""
                    }`}
                  >
                    <i className="far fa-calendar menu-lateral__icone" />
                    <span className="menu-lateral__texto">Agenda</span>
                  </a>
                </li>
              </>
            )}
          </>
        )}
      </ul>
    </nav>
  );
};

export default MenuLateral;
